import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL3 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'

const pageSize = 5;
const OatDepartmentMain = () => {

  // GET request using fetch()
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
const token = JSON.parse(localStorage.getItem('usertoken'));
const [allusers, setAllusers] = useState([])


const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);

useEffect(()=>{  
  document.getElementById("OatDepartmentTable").style.display="none"

 
  getUsers()
  setpop(true);
  setTimeout(() => {
            
    getroleAction() 
    
     }, 1000);
  setTimeout(() => {
          
    setpop(false);
    getAssignedAction()
  
      
     }, 2000);


}, [])
function getroleAction(){


  let LoginRole= localStorage.getItem("Role");
  
 
  console.log('checkrole',LoginRole);
  const body =
  {
    
   role:LoginRole
  }
  console.log('body',body);
 
 
  axios({
         method:"POST",
         url :`${BASE_URL}/oat/GetOatRoleAction`,
         data:body, 
         headers: {
              "Content-type": "application/json",
              "Authorization": bearer,
          }     
      }) 
      
 
      .then((response) =>{
        console.log(response.data);
   
     
     
              
        localStorage.setItem("LoginAction",JSON.stringify(response.data))
        localStorage.getItem("LoginAction");
     })
     .catch(error => {
       console.log(error);
 })
 }
 function getAssignedAction(){



  ////Admin
    
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


    document.getElementById('OatDepartmentTable').style.display ="block";

   
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('DepartmentTable-Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('DepartmentTable-Oat').style.display ="block";
    }
    else{
      document.getElementById('DepartmentTable-Oat').style.display ="none";

    }

    

    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="View Table Denied"
    }
   
    
  }

  function getUsers(){

    
    console.log("Token", token)
  fetch(`${BASE_URL}/OatMain/GetDepartment`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

     

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data);
      setAllusers(data);
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );

console.log("check",allusers)


      }

      const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
      // if (pageCount === 1)
      // return null;
      
      const pages = _.range(1, pageCount+1)
      
      const pagination =(pageNo)=>{
      setcurrentPage(pageNo);
      const startIndex = (pageNo - 1) * pageSize;
      const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
      setpaginatedPosts(paginatedPost)
      }

      const onNext = () => {


        pagination(currentPage + 1);
      };
    
      const onPrevious = () => {
        pagination(currentPage - 1);
      };
  

  return (
    <>
    
    <div className='oat-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
       <div className="oat-addgrid-layout">
    
    <div className="oat-addmain-top">
       
      <span className='OatTitle'>
      <span>DEPARTMENT</span></span>
      <div className='oat-addmain-back'>
      <Link to="/OatCategory"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     
      </div> </div>

      <div id="OatDepartmentTable">
     
    
<div id="DepartmentTable-Oat" style={{marginTop:"-35px"}}>
{
 allusers.length==0? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
<th>Id</th>
<th>Department</th>


{/* <th>Seen</th>
<th>Created_Date</th> */}



</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

           <td>{e.id}</td>
          <td>{e.department}</td>
          
         
          {/* <td>{e.seen}</td>
          <td>{e.created_Date}</td> */}
          
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCount==1?null:<nav id="oatpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
        */}

{currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)} 
  </div>

  <div id="OatDenied">
   <span id="OatActionDenied"></span>

   </div>
        </div>


     

      {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    </div>
    </>
  )
}

export default OatDepartmentMain
